<template>
  <div
    class="minimal-intro generic-minimal-intro-item minimal-intro--generic relative c-bg-1 border-radius flex flex-stretch padding-m l:padding-l"
    @click="$router.push(finalItemRoute)">
    <div
      class="bg absolute-cover z-level-1 border-radius background-cover"
      :style="`background-image: url('${imageUrl}');`"></div>
    <div class="gradiant-shader background-cover z-level-2"></div>
    <badge
      v-if="showBadge"
      class="item-badge absolute z-level-3 border-radius"
      :text="badgeText"
      :icon="badgeIcon"
      :theme="badgeTheme"
      size="m"></badge>
    <div
      class="content relative min-size-parent z-level-4 border-radius flex-column flex-end"
      style="width: 100%">
      <div class="content-inner">
        <div class="content-block width-expand max-width-300 margin-auto-top" style="">
          <h3 class="item-title margin-s-bottom text-bold text-xl l:text-3xl">
            {{ title }}
          </h3>
          <p class="margin-top-remove margin-m-bottom l:margin-s-bottom text-l l:text-xl">
            {{ text }}
          </p>
        </div>
        <div class="read-more-cta width-expand flex-end text-m l:text-l">
          <saffron-link class="plain-link" :to="finalItemRoute">
            <icon-text icon="chevron-inline-end" class="flex-row-reverse c-bg-1">
              <slot name="read-more-text">{{
                tu("ag.item.minimalIntro.readMoreCta")
              }}</slot>
            </icon-text>
          </saffron-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GenericListItem",
  props: {
    title: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    badgeTheme: {
      type: String,
      default: "inverse",
    },
    badgeText: {
      type: String,
      default: "",
    },
    showBadge: {
      type: Boolean,
      default: true,
    },
    badgeIcon: {
      type: [String, Boolean],
      default: false,
    },
    translateBadgeText: {
      type: Boolean,
      default: true,
    },
    imageUrl: {
      type: String,
      default: false,
    },
    itemRoute: {
      type: [String, Object, Boolean, Function],
      default: false,
    },
    // we want error to be generated if  "item" is not provided
    // eslint-disable-next-line vue/require-default-prop
    item: {
      type: Object,
    },
  },
  data: function () {
    return {};
  },
  computed: {
    type() {
      return utilities.lcFirst(this.item.type);
    },
    configRouteFunction() {
      return config?.items?.types[this.type]?.routeFunction;
    },
    hasTypeRouteFunctionInConfig() {
      return typeof this.configRouteFunction === "function";
    },
    hasItemRoute() {
      if (this.hasTypeRouteFunctionInConfig) {
        return true;
      }
      return !!this.itemRoute;
    },
    finalItemRoute() {
      if (typeof this.itemRoute === "string" || typeof this.itemRoute === "object") {
        return this.itemRoute;
      }

      if (typeof this.itemRoute === "function") {
        return this.itemRoute();
      }

      if (this.hasTypeRouteFunctionInConfig) {
        return this.configRouteFunction(this.item);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.content-inner {
  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.5);
  line-height: 1;

  h3 {
    line-height: 1;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1; /* number of lines to show */
    line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  p {
    line-height: 1;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}

.gradiant-shader {
  position: absolute;
  height: 20%;
  min-height: 150px;
  bottom: 0;
  inset-inline-start: 0;
  width: 100%;
  background: linear-gradient(178.7deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 50%);
  border-start-start-radius: 0;
  border-start-end-radius: 0;
  border-end-start-radius: var(--border-radius);
  border-end-end-radius: var(--border-radius);

  @media (max-width: 767px) {
    height: 100%;
    background: linear-gradient(
      178.7deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.05) 25%,
      rgba(0, 0, 0, 0.3) 50%,
      rgba(0, 0, 0, 0.6) 75%
    );
  }
}

.item-badge {
  position: absolute;
  top: var(--margin-l);
  inset-inline-start: var(--margin-l);

  @media (max-width: 1024px) {
    top: var(--margin-m);
    inset-inline-start: var(--margin-m);
  }
}
</style>
